import api from "./api";
import { getAuthToken, getUserEmail } from "./auth";

export async function getUser() {
  const userEmail = getUserEmail();
  const authToken = getAuthToken();
  if (!userEmail || !authToken) throw new Error("No email or token found");
  const user = await api.get("/auth/user");
  return { ...user.data };
}
